import { observer } from 'mobx-react'
import React from 'react'
import { Calendar } from '../../Components/Calendar/Calendar'

export default observer(({ date, staffId }) => (
    <div style={{ width: '80em' }}>
        <Calendar mode="time" date={date} staffId={staffId} />
    </div>
))
